import { PropsWithChildren } from 'react';

import { ToPortal } from 'core/portals';
import { useChatVisibilityToggle } from 'hooks/useChatVisibilityToggle';

type Props = PropsWithChildren<unknown>;

export const PageFooter = ({ children }: Props) => {
  // Pylon chat bubble covers footer actions on the bottom of the page
  useChatVisibilityToggle(true);

  return <ToPortal portal="PAGE_FOOTER">{children}</ToPortal>;
};
